import { baseAxios } from "./apiDefault";
import promiseHandler from "@/utils/promise";

export const increaseBalance = async data =>
  promiseHandler(baseAxios().post("user/api/v1.0/Payment/Pay", data));

export const verifyPeyment = async data =>
  promiseHandler(baseAxios().get(`user/api/v1.0/Payment/Verify?${data}`));

export const paymentList = async () =>
  promiseHandler(baseAxios().get("user/api/v1.0/Payment/list"));

export const costReport = async () =>
  promiseHandler(baseAxios().get("user/api/v1.0/costReport/list"));

/**************************Admin***************************/

export const paymentListAdmin = async () =>
  promiseHandler(baseAxios().get("admin/api/v1.0/Payment/list"));
